<script lang="ts" setup></script>

<template>
  <div class="flex flex-col justify-between w-full items-center pt-[6px]">
    <img src="../assets/icons/done_icon.svg" alt="" class="w-[48.75px] h-[48.75px]" />
    <div class="text-base text-light-mode-high-contrast !font-semibold !mb-2 mt-[22px]">Thanks for letting us know</div>
    <div class="text-light-mode-low-contrast !text-sm font-normal text-center w-[258px]">
      We’ll use this responses to improve your experience better.
    </div>
  </div>
</template>
